import constants from '#packages/constants';

import type { ComponentEditorMetaDataDefinition } from '../types';

import { documentTypeUtils } from '@wix/santa-editor-utils';

const metaData: ComponentEditorMetaDataDefinition = {
  allowConnectToDB: true,
  skipInQuickEditPanel: true,
  overrideProportionalResize: true,
  overridesWhenReferred: {
    gfpp: {
      disableActions: [constants.ROOT_COMPS.GFPP.ACTIONS.DESIGN],
    },
  },
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};

export default metaData;
